import { Component } from '@angular/core';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
    this.matIconRegistry.addSvgIcon(
      "TheMLS-logo",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../Scripts/wwwroot/photographer-network/assets/images/logo/TheMLS-logo.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "VestaPlus-logo",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../Scripts/wwwroot/photographer-network/assets/images/logo/VestaPlus-logo.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "Homesnap",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../Scripts/wwwroot/photographer-network/assets/images/logo/Homesnap.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "searchTerms",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../Scripts/wwwroot/photographer-network/assets/images/preferredPhotographerNetwork/searchTerm__icon.svg")
    );
  }

  title = 'photographer-network';
}
